{
  "title": "Snilloc's Snowball Storm",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "2nd-level evocation",
  "level": 2,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (a piece of ice or a small white rock chip)",
  "duration": "Instantaneous",
  "description": [
    "A flurry of magic snowballs erupts from a point you choose within range. Each creature in a 5-foot-radius sphere centered on that point must make a Dexterity saving throw. A creature takes 3d6 cold damage on a failed save, or half as much damage on a successful one.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, the damage increases by 1d6 for each slot level above 2nd."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "wizard"]
}
